import * as React from "react";
// import {Link} from 'react-router-dom'
import {
  Button,
  Container,
  Dropdown,
  // Form,
  Modal,
  Tab,
  Tabs,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { ModuleReports } from "../../Common/Services/ModuleReports";
import { FiChevronDown } from "react-icons/fi";
import { ReportRunner } from "./ReportRunner";
import { ReportGallery } from "./ReportGallery";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { toast } from "react-toastify";
import { ScheduleReportLeftPanel } from "./ScheduleReports/ScheduleReportLeftPanel";
import { ScheduleReportRightPanel } from "./ScheduleReports/ScheduleReportRightPanel";
import { ReportExport } from "../../Common/Services/ReportExport";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { resolve, reject } from "q";
import OutsideClickHandler from "react-outside-click-handler";
import { ReactPageLoader } from "../../Common/Components/ReactPageLoader";
import "../../Common/Assets/Styles/Modules/reports.scss";
import moment from "moment-timezone";
import { Utils } from "../../Common/Utilis";
let reportTagList = [] as any;
export class ReportSelection extends React.Component<any, any> {
  private childHID: any;
  private childLeftPanel: any;
  private childRightPanel: any;
  private linkRef: any;
  private timerId: any;
  constructor(props: any) {
    super(props);
    this.linkRef = React.createRef();
    this.childLeftPanel = React.createRef();
    this.childRightPanel = React.createRef();
    this.state = {
      moduleReports: [] as any,
      allmoduleReports: [] as any,
      filteredData: [] as any,
      showReport: false,
      runFrom: "myreports",
      reportData: {},
      employeeList: [],
      reportPermissions: [],
      reportTypes: [] as any,
      search: "",
      newReportName: "",
      showRenameModal: false,
      currentRow: {} as any,
      isDuplicate: false,
      activeTab: "myreports",
      sortingOrder: "Alphabetical",
      showReportGallery: false,
      reportType: "Report Type",
      selectedReportType: -1,
      showRightPanel: false,
      allowScheduleEdit: false,
      allowScheduleView: false,
      disableDelete: false,
      loaderTrue: false,
      startDateTime: {},
      endTime: {},
      startTime: {},
      rptStartDate: {},
      rptEnDate: {},
      clickType: "",
      lastAPD: [],
      throughAPD: [],
    };
  }

  componentDidMount() {
    this.getReports();
    this.GetLastActivePeriod();
    this.GetServerDate();
  }

  GetLastActivePeriod = () => {
    ModuleReports.GetlastActivePeriods(0).then(async (result: any | null) => {
      if (result != null && result.length > 0) {
        this.setState({ lastAPD: result });
      }
    }).catch((err: any) => {
      Utils.toastError(`Server Error, ${err}`, {});
    });
  }

  GetServerDate = () => {
    ModuleReports.GetSeverDateTime(0).then(async (result: any | null) => {
      if (result != null && result.length > 0) {
        this.setState({ throughAPD: result });
      }
    }).catch((err: any) => {
      Utils.toastError(`Server Error, ${err}`, {});
    });
  }


  getReports() {
    this.getModuleReports();
    this.getScheduleReportPermissions();
  }
  getScheduleReportPermissions = () => {
    let requestObject = {} as any;
    requestObject.permissionID = 2281;
    requestObject.Module = "All";
    requestObject.Type = "page";
    this.setState({ loaderTrue: true });

    ModuleReports.GetPagePermissionData(requestObject)
      .then(async (result: any | null) => {
        if (result != null && result.length > 0) {
          let editExist = result.filter(
            (x) => x.permissionName.toLowerCase() === "edit"
          );
          if (editExist && editExist.length > 0) {
            this.setState({ allowScheduleEdit: true });
          }
          let viewExist = result.filter(
            (x) => x.permissionName.toLowerCase() === "view"
          );
          if (viewExist && viewExist.length > 0) {
            this.setState({ allowScheduleView: true });
          }
        }
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {

        });
      });
  };

  getReportPermissions = () => {
    let requestObject = {} as any;
    ModuleReports.GetReportPermissionData(requestObject)
      .then(async (result: any | null) => {
        if (result != null && result.length > 0) {
          this.setState({ reportPermissions: result }, () => {
            this.getUserReport();
          });
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "reportGallerySelection",
        });
        reject();
      });
  };

  getModuleReports() {
    ModuleReports.getModuleReports(4)
      .then((result: any) => {
        if (result != null) {
          const data = result.result;
          this.setState({
            allmoduleReports: data,
          });
          this.getReportPermissions();
        }
      })
      .catch((error) => {
        // Need to handle this ok jee
        console.log(error);
      });
  }

  getUserReport = () => {
    this.setState({
      moduleReports: [],
      filteredData: [],
    })
    ModuleReports.GetUserReport()
      .then((result: any[]) => {
        if (result != null && result.length > 0) {
          const data = result;
          let allowedReports = [] as any;
          data.forEach((report: any) => {
            if (report.parentId > 0) {
              let parentReport = this.state.allmoduleReports.filter(
                (x) => x.moduleReportId === report.parentId
              );
              if (parentReport.length > 0) {
                let hasPermission = this.state.reportPermissions.filter(
                  (x) =>
                    x.permissionName.toLowerCase() ===
                    parentReport[0].reportName.toLowerCase()
                );
                if (hasPermission && hasPermission.length > 0) {
                  allowedReports.push(report);
                }
              }
            } else {

              let hasPermission = this.state.reportPermissions.filter(
                (x) =>
                  x.permissionName.toLowerCase() ===
                  report.reportName.toLowerCase() || +x.permissionID === +report?.permissionId
              );
              if (hasPermission && hasPermission.length > 0) {
                allowedReports.push(report);
              }
            }
          });
          allowedReports.sort((a, b) =>
            a["userReportName"].localeCompare(b["userReportName"])
          );
          this.setState({
            moduleReports: allowedReports,
            filteredData: allowedReports,
            reportType: "Report Type",
            loaderTrue: false,
            search: "",
          });
          let reportTypes = [] as any;
          if (allowedReports.length > 0) {
            reportTypes = [
              ...allowedReports
                .map((item) => item.reportName)
                .filter((value, index, self) => self.indexOf(value) === index),
            ];
          }
          reportTypes = [
            "All",
            ...reportTypes.sort((a, b) => a?.localeCompare(b)),
          ];
          this.setState({ reportTypes });
        } else {
          this.setState({
            moduleReports: [],
            filteredData: [],
            loaderTrue: false,
            reportTypes: [],
          });
        }
      })
      .catch((error) => {
        // Need to handle this
        this.setState({
          moduleReports: [],
          filteredData: [],
          reportTypes: [],
          loaderTrue: false,
        });
      });
  };

  onShowReport = (e, row, runfrom) => {
    if (!row.reportParameter) {
      row.reportParameter = row.parameters;
    }
    this.setState({ reportData: row, showReport: true, runFrom: runfrom });
    if (row.reportName == "Department Permission Report" || row.reportName == "Role Permission") {
      this.logReportLoadTiming('onstart', '')
    }
  };

  logReportLoadTiming = (callFrom, reportRunParams) => {
    debugger;
    if (callFrom === 'onstart') {
      let startTime = new Date()
      let reportdate = new Date()
      const format1 = "MM/D/YYYY HH:mm:ss"
      let rptStartDate = moment.utc(reportdate).format(format1);
      this.setState({ rptStartDate: rptStartDate, startDateTime: startTime, clickType: "runreport" });
    };
    // setStartDateTime(startTime)

    if (callFrom === 'onload') {
      this.timerId = setInterval(() => {
        this.calculateRenderTime(reportRunParams)
      }, 1000)
    }
  }
  calculateRenderTime = async (reportRunParams) => {
    let loader = document.getElementById("reportviewer-container_loadingIndicator")?.style.display;
    if (loader === 'none' && this.state.clickType === "runreport") {
      debugger;
      let endTime: any = new Date();
      let timeinMS: any = endTime - this.state.startDateTime
      let reportdate = new Date()
      const format1 = "MM/D/YYYY HH:mm:ss"
      let rptEnDate = moment.utc(reportdate).format(format1);
      //  setrptEnDate(rptEnDate);
      this.setState({ rptEnDate })
      // console.log(timeinMS);
      const reportRenderMinutSecond = this.millisToMinutesAndSeconds(timeinMS);
      const reportName = reportRunParams.find(({ name }) => name === "reportName")?.value.toString() ?? ''
      let runReportDateTime = this.state.rptStartDate;
      let runReportEndDateTime = rptEnDate;
      let reportRenderInMS = timeinMS;
      const reportParam = JSON.stringify(reportRunParams);
      let type = "fromReportRender"
      // console.log(reportRenderMinutSecond);

      clearInterval(this.timerId);
      const result: any[] = await ModuleReports.InsertRunReportDetails(reportName, runReportDateTime.toString(), runReportEndDateTime, reportRenderInMS, reportRenderMinutSecond, reportParam, type);
      this.setState({ clickType: "" });
    } else {
      clearInterval(this.timerId);
    }
  }
  millisToMinutesAndSeconds(millis) {
    const a = '00'
    let minutes = Math.floor(millis / 60000);
    let seconds = ((millis % 60000) / 1000).toFixed(Number(0));
    const parts = [
      minutes, (Number(seconds) < 10 ? '0' : '') + seconds
    ];
    return a + ":" + parts.map(s => String(s).padStart(2, '0')).join(':');
    //console.table(formatted);

  }

  hideModal = (runFrom) => {
    if (runFrom !== "gallery") {
      this.setState({ showReport: false, showReportGallery: false }, () => {
        this.getUserReport();
      });
    } else {
      this.setState({ showReport: false }, () => {
        this.getUserReport();
      });
    }
  };

  filterReports = (reportType: any) => {
    this.setState({ reportType }, () => this.filterReportData());
  };

  searchReport = (e) => {
    this.setState({ search: e.target.value }, () => this.filterReportData());
  };

  filterReportData = () => {
    const { moduleReports, search, reportType } = this.state;
    let filteredReport = [...moduleReports];

    if (search) {
      filteredReport = filteredReport.filter(
        (x) =>
          x.reportName?.toLowerCase().includes(search.toLowerCase()) ||
          x.userReportName?.toLowerCase().includes(search.toLowerCase()) ||
          x.reportTag?.toLowerCase().includes(search.toLowerCase()) ||
          x.createdDate?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (!(reportType === "All" || reportType === "Report Type")) {
      filteredReport = filteredReport.filter(
        (x) => x.reportName === reportType
      );
    }

    this.setState({ filteredData: filteredReport });
  };

  renameReport = (e: any, row: any) => {
    this.setState({
      currentRow: row,
      showRenameModal: true,
      newReportName: row.userReportName,
      isDuplicate: false,
    });
  };

  deleteReport = (e: any) => {
    this.setState({ disableDelete: true });
    ModuleReports.deleteUserReport(this.state.currentRow.userReportId)
      .then((result: any) => {
        this.setState({ disableDelete: false, showdeleteConfirmation: false });
        if (result.success === true) {
          this.getUserReport();
          toast.success(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "reportSelection",
          });
        }
      })
      .catch((error) => {
        this.setState({ disableDelete: false, showdeleteConfirmation: false });
      });
  };

  cancelDelete = (e: any) => {
    let filteredDT = [...this.state.filteredData]
    this.setState({ currentRow: {}, showdeleteConfirmation: false, filteredData: [] }, () => {
      this.setState({ filteredData: filteredDT })
    });
  }

  confirmDelete = (row) => {
    let filteredDT = [...this.state.filteredData]
    this.setState({ currentRow: row, showdeleteConfirmation: true, filteredData: [] }, () => {
      this.setState({ filteredData: filteredDT })
    });
  };

  duplicateReport = (e, row) => {
    this.setState({
      currentRow: row,
      showRenameModal: true,
      newReportName: "Copy of " + row.userReportName,
      isDuplicate: true,
    });
  };

  hideRenameModal = () => {
    this.setState({ showRenameModal: false });
  };

  saveNewReportName = () => {

    if (this.state.newReportName.trim().length === 0) {
      Utils.toastError("Please enter Report Name", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "reportSelection",
      });
      return false;
    }
    this.setState({ disableSave: true });
    if (this.state.isDuplicate) {
      ModuleReports.duplicateUserReport(
        this.state.currentRow.userReportId,
        this.state.newReportName
      )
        .then((result: any) => {
          this.setState({ disableSave: false });
          if (result.success === true) {
            this.getUserReport();
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "reportSelection",
            });
            this.setState({ showRenameModal: false });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "reportSelection",
            });
          }
        })
        .catch((error) => {
          this.setState({ disableSave: false });
        });
    } else {
      ModuleReports.renameUserReport(
        this.state.currentRow.userReportId,
        this.state.newReportName
      )
        .then((result: any) => {
          this.setState({ disableSave: false });
          if (result.success === true) {
            this.getUserReport();
            this.setState({ showRenameModal: false });
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "reportSelection",
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "reportSelection",
            });
          }
        })
        .catch((error) => {
          this.setState({ disableSave: false });
        });
    }
  };

  changeReportName = (e) => {
    this.setState({ newReportName: e.target.value });
  };

  sortReports = (sortBy) => {
    let sortReports = [...this.state.moduleReports];
    const data = sortReports;
    if (sortBy === "Alphabetical") {
      data.sort((a, b) =>
        a["userReportName"].localeCompare(b["userReportName"])
      );
      this.setState({ moduleReports: data });
    }
  };

  hideReportGalleryModal = () => {
    this.setState({
      showReportGallery: false,
      reportType: "Report Type",
      search: "",
    });
    this.getUserReport();
  };

  handleSelectedItem = (controlID: any, id: any) => {
    this.setState({ selectedReportType: id });
  };

  exportReport = (userReportName, exportFormat = "PDF") => {
    let reportParameters = JSON.parse(
      localStorage.getItem("reportParameters")!
    );

    // reportParameters.push({ name: "writerFormat", value: exportFormat });
    const nameIndex = reportParameters.map((p) => p.name).indexOf("writerFormat");
    let currentReportParameters = reportParameters;
    if (nameIndex > -1) {
      currentReportParameters.splice(nameIndex, 1);
    }
    currentReportParameters.push({ name: "writerFormat", value: exportFormat });


    let item = currentReportParameters.find(item => item.name === "writerFormat");

    if (item.value.toUpperCase() === "CSV") {
      ReportExport.reportDownloadCSV(JSON.stringify(reportParameters)).then(
        (result) => {
          debugger;
          const href = window.URL.createObjectURL(result);
          const a = this.linkRef.current;
          a.download = userReportName + `.${exportFormat.toLowerCase()}`;
          a.href = href;
          a.click();
          a.href = "";
        }
      );
    }
    else {
      ReportExport.reportDownload(JSON.stringify(reportParameters)).then(
        (result) => {
          const href = window.URL.createObjectURL(result);
          const a = this.linkRef.current;
          a.download = userReportName + `.${exportFormat.toLowerCase()}`;
          a.href = href;
          a.click();
          a.href = "";
        }
      );
    };
  };

  openReportGallery = () => {
    if (this.state.activeTab === "scheduled") {
      if (this.childRightPanel && this.childRightPanel.current) {
        let result = this.childRightPanel.current.checkUnSavedChanges(
          "opengallery", "myreports"
        );
        if (result === true) {
          return result;
        }
      }
    }
    this.setState({ showReportGallery: true });
  };
  confirmOpenReportGallery = () => {
    this.setState({ showReportGallery: true, showRightPanel: false });
  };
  confirmsetActiveTab = (tab) => {
    this.setState({ activeTab: tab, showRightPanel: false });
  };

  setActiveTab = (selectedtab) => {
    if (this.state.activeTab === "scheduled") {
      if (this.childRightPanel && this.childRightPanel.current) {
        let result = this.childRightPanel.current.checkUnSavedChanges(
          "tabchange", selectedtab
        );
        if (result === true) {
          return result;
        }
      }
    }

    if (selectedtab === "myreports") {
      this.getReports();
    }
    this.setState({ activeTab: selectedtab, showRightPanel: false }, () => {
      if (selectedtab === "scheduled") {
        if (this.childLeftPanel && this.childLeftPanel.current) {
          this.childLeftPanel.current.getUserScheduleReport(null);
        }
      }
    });
  };

  openScheduleTab = (reportData, showrightpanel) => {
    this.setState({ showReport: false, showReportGallery: false }, () => {
      this.setState(
        {
          activeTab: "scheduled",
          showRightPanel: showrightpanel,
        },
        () => {
          if (showrightpanel === false) {
            this.childLeftPanel.current.resetSelection(0);
          } else {
            if (this.childLeftPanel && this.childLeftPanel.current) {
              this.childLeftPanel.current.resetSelection(0);
              this.childLeftPanel.current.getUserScheduleReport(reportData);
            }
            this.showRightPanelData(reportData);
          }
        }
      );
    });
  };

  showRightPanelData = (selectedRow) => {
    this.setState(
      {
        showRightPanel: true,
      },
      () => {
        if (this.childRightPanel && this.childRightPanel.current) {
          this.childRightPanel.current.updateData(selectedRow);
        }
      }
    );
  };

  hideRightPanel = () => {
    this.setState({ showRightPanel: false }, () => {
      if (this.childLeftPanel && this.childLeftPanel.current) {
        this.childLeftPanel.current.resetSelection(0);
      }
    });
  };

  reloadLeftPanel = (uniqueNo) => {
    if (this.childLeftPanel && this.childLeftPanel.current) {
      this.childLeftPanel.current.getUserScheduleReport(null);
      this.childLeftPanel.current.resetSelection(uniqueNo);
    }
  };

  onduplicateReport = (uniqueNo) => {
    if (this.childLeftPanel && this.childLeftPanel.current) {
      this.childLeftPanel.current.duplicateReport(uniqueNo);
    }
  };

  getAllReportTags(reportTag) {
    let tagArr = [] as any;
    if (reportTag) {
      tagArr = reportTag.split(",");
    }

    let messageArr = [] as any;
    messageArr = [...tagArr];
    if (messageArr.length > 0) {
      messageArr.splice(0, 1);
    }
    if (messageArr.length > 0) {
      messageArr.splice(0, 1);
    }
    const tooltipMessage = messageArr.join(", ");
    if (tagArr.length > 2) {
      return (
        <div className="report-tag rm-bg">
          <button type="button" className="showalltags d-flex">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.9999 2.3999C7.59665 2.3999 7.26947 2.72709 7.26947 3.13034V7.26947H3.13034C2.72709 7.26947 2.3999 7.59665 2.3999 7.9999C2.3999 8.40315 2.72709 8.73034 3.13034 8.73034H7.26947V12.8695C7.26947 13.2727 7.59665 13.5999 7.9999 13.5999C8.40315 13.5999 8.73034 13.2727 8.73034 12.8695V8.73034H12.8695C13.2727 8.73034 13.5999 8.40315 13.5999 7.9999C13.5999 7.59665 13.2727 7.26947 12.8695 7.26947H8.73034V3.13034C8.73034 2.72709 8.40315 2.3999 7.9999 2.3999Z" />
            </svg>
            {tagArr.length <= 2 ? (
              ""
            ) : (
              <div style={{ marginTop: "1px", paddingRight: "2px" }}>
                {" "}
                {tagArr.length - 2} More
              </div>
            )}
            <div className="tooltip bs-tooltip-bottom tooltip-custom">
              <div className="arrow"></div>
              <div className="tooltip-inner">{tooltipMessage}</div>
            </div>
          </button>
        </div>
      );
    }
  }
  getReportTags(reportTag) {
    let tagArr = [] as any;
    if (reportTag) {
      tagArr = reportTag.split(",");
    }
    let tags = [] as any;
    tagArr.map((tag, index) => {
      if (reportTagList.filter((x) => x.value === tag).length === 0) {
        let newItem = {} as any;
        newItem.tagId = index;
        newItem.value = tag;
        newItem.description = tag;
        newItem.isChecked = false;
        reportTagList.push(newItem);
      }
      if (tags.length <= 1) {
        tags.push(
          <div key={tag} className="report-tag">
            <EllipsisWithTooltip placement="bottom">{tag}</EllipsisWithTooltip>
          </div>
        );
      }
    });
    return tags;
  }

  render() {
    let ModuleName = "Labor";
    let str = window.location.href;
    if (str.includes("Account-management")) {
      ModuleName = "Accounting";
    }
    else if (str.includes("labor-management")) {
      ModuleName = "Labor";
    }





    const columns = [
      {
        dataField: "userReportId",
        hidden: true,
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.onShowReport(e, row, "myreports");
          },
        },
      },
      {
        dataField: "userReportName",
        text: "Report",
        formatter: (cell, row) => (
          <div className="user-report-details d-flex">
            <EllipsisWithTooltip placement="bottom">
              <span className="user-report-name">{row.userReportName}</span>
            </EllipsisWithTooltip>
            <span className="report-created-date">
              Created {row.createdDate}
            </span>
          </div>
        ),
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.onShowReport(e, row, "myreports");
          },
        },
      },
      {
        dataField: "reportName",
        text: "Report Type",
        formatter: (cell, row) => (
          <div className="user-report-type d-flex">
            <span className="user-report-name">{row.reportName}</span>
            <span className="report-type-label">Report Type</span>
          </div>
        ),
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.onShowReport(e, row, "myreports");
          },
        },
      },
      {
        dataField: "",
        text: "Report Tags",
        formatter: (cell, row) => (
          <div className="user-report-type d-flex">
            <span className="user-report-name d-flex align-items-center">
              {this.getReportTags(row.reportTag)}
              {this.getAllReportTags(row.reportTag)}
            </span>
            <span className="report-type-label">Report Tags</span>
          </div>
        ),
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.onShowReport(e, row, "myreports");
          },
        },
      },
      {
        dataField: "",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) => (
          <Dropdown
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="more-action"
            alignRight
          >
            <Dropdown.Toggle
              className="btn-outline-primary btn btn-primary btn-ghost more"
              id="dropdown-more"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                key={"rename"}
                eventKey={"rename"}
                onClick={(e: any) => this.renameReport(e, row)}>
                Rename
              </Dropdown.Item>
              <Dropdown.Item
                key={"duplicate"}
                eventKey={"duplicate"}
                onClick={(e: any) => this.duplicateReport(e, row)}>
                Duplicate
              </Dropdown.Item>
              <Dropdown.Item
                key={"delete"}
                eventKey={"delete"}
                onClick={(e: any) => this.confirmDelete(row)}>
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
            {this.state.showdeleteConfirmation &&
              this.state.currentRow.userReportId === row.userReportId && (
                <div className="deleteReport confirmModal">
                  <OutsideClickHandler
                    onOutsideClick={() =>
                      this.setState({ showdeleteConfirmation: false })
                    }>
                    <div className="deleteReportDropdown">
                      <div className="deleteReportBody">
                        <div className="title">Delete User Report</div>
                        <div className="description deleteReportTxt">
                          <p>
                            Are you sure you want to delete this report{" "}
                            <b>{this.state.currentRow.userReportName}</b> ?
                          </p>
                        </div>
                      </div>
                      <div className="deleteReportFooter action-link">
                        <button
                          className="deleteReportCancel btn wht-bg"
                          onClick={(e) => this.cancelDelete(e)}
                        >
                          Cancel
                        </button>
                        <button
                          disabled={this.state.disableDelete}
                          className="deleteReportDelete btn btn-primary btn-danger"
                          onClick={(e) => this.deleteReport(e)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </OutsideClickHandler>
                </div>
              )}
            {/* { this.state.showdeleteConfirmation && 
            <div className="deleteReport">
              <OutsideClickHandler
                onOutsideClick={() =>
                  this.setState({ showdeleteConfirmation: false })
                }
              >
                <div className="deleteReportDropdown">
                  <div className="deleteReportBody">
                    <div className="deleteReportHeading">
                      Delete Scheduled Report
                    </div>
                    <div className="deleteReportTxt">
                      <p>
                        Are you sure you want to delete this scheduled
                        report <b>{this.state.newReportName}</b> ?
                      </p>
                    </div>
                  </div>
                  <div className="deleteReportFooter action-link">
                    <button
                      className="deleteReportCancel btn wht-bg"
                      onClick={() =>
                        this.setState({
                          showdeleteConfirmation: false,
                        })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      className="deleteReportDelete btn btn-primary btn-danger"
                     // onClick={() => this.deleteScheduleReport()}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </OutsideClickHandler>
            </div>
                    } */}
          </Dropdown>
        ),

        // events: {
        //   onClick: (e, column, columnIndex, row, rowIndex) => {
        //     this.onShowReport(e, row, "myreports");
        //   },
        // },
      },
    ];
    return (
      <div className="reports-main">
        <Container fluid className="body-sec">
         {/* <ToastContainer
            enableMultiContainer
            autoClose={3000}
            containerId={"reportSelection"}
          /> */} 
          <div className="page-heading underline d-flex">
            <div className="mr-auto">{ModuleName === "Accounting" ? "My Accounting Reports" : "My Labor Reports"}</div>
            <div className="action-group d-flex flex-row">
              {<a ref={this.linkRef}></a>}
              <Button
                className="report-gallery"
                onClick={() => this.openReportGallery()}
              >
                Report Gallery
              </Button>
              {/* <Dropdown className="more-action" alignRight>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                </Dropdown.Menu>
              </Dropdown> */}
            </div>
          </div>

          <Tabs
            id="controlled-tab-example"
            activeKey={this.state.activeTab}
            onSelect={(selectedtab) => this.setActiveTab(selectedtab)}
          >
            <Tab eventKey="myreports" title="My Reports">
              {this.state.loaderTrue ? (
                <ReactPageLoader useas={"reportsMain"} />
              ) : (
                <>
                  <div className="section" style={{ display: "flex" }}>
                    <div className="main-Page">
                      <div className="navigation-menus d-flex">
                        <div className="schedule-table-search">
                          <input
                            type="text"
                            className="form-control "
                            placeholder="Search..."
                            value={this.state.search}
                            onChange={(e) => this.searchReport(e)}
                          />
                        </div>

                        <div className="report-type-dropdown ml-2 mr-2">
                          <Dropdown className="more-action bg-blue">
                            <Dropdown.Toggle id="someId">
                              <div className="d-flex align-items-center">
                                {this.state.reportType}
                                <div className="drop-arrow d-flex">
                                  <FiChevronDown />
                                </div>
                              </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {this.state.reportTypes.map(
                                (item: any, idx: any) => (
                                  <Dropdown.Item
                                    key={item}
                                    eventKey={item}
                                    onClick={(e: any) =>
                                      this.filterReports(item)
                                    }
                                  >
                                    {item}
                                  </Dropdown.Item>
                                )
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        {/* <div className="navigationSort ml-auto">
                      <Dropdown className="more-action bg-blue" alignRight>
                        <Dropdown.Toggle className="" id="dropdown-more">
                          <div className="d-flex align-items-center">
                            <svg
                              width="16"
                              height="12"
                              viewBox="0 0 16 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.5 12L6.5 9H4.25V0H2.75V9H0.5L3.5 12ZM7.25 3H14V4.5H7.25V3ZM7.25 6H12.5V7.5H7.25V6ZM7.25 0H15.5V1.5H7.25V0ZM7.25 9H11V10.5H7.25V9Z" />
                            </svg>
                            Alphabetical
                            <div className="drop-arrow d-flex">
                              <FiChevronDown />
                            </div>
                          </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Header>SORT</Dropdown.Header>
                          <Dropdown.Item
                            className={
                              this.state.sortingOrder === "Alphabetical"
                                ? "active"
                                : ""
                            }
                            onClick={(e: any) =>
                              this.sortReports("Alphabetical")
                            }
                          >
                            <div className="d-flex">
                              <div className="mr-auto">Alphabetical</div>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.49998 11.6895L5.03023 9.21973L3.96973 10.2802L7.49998 13.8105L14.7802 6.53023L13.7197 5.46973L7.49998 11.6895Z"
                                  fill="#2CAF92"
                                />
                              </svg>
                            </div>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div> */}
                      </div>

                      <div className="reports-table">
                        {this.state.filteredData.length > 0 && (
                          <div className="max-height">
                            <ToolkitProvider
                              keyField="id"
                              remote
                              data={this.state.filteredData}
                              columns={columns}
                              search
                            >
                              {(toolkitprops: any) => [
                                <BootstrapTable {...toolkitprops.baseProps} />,
                              ]}
                            </ToolkitProvider>
                          </div>
                        )}

                        {this.state.filteredData.length === 0 && (
                          <div className="blank-data-screen">
                            <span className="icon d-block">
                              <svg
                                width="128"
                                height="128"
                                viewBox="0 0 128 128"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="64" cy="64" r="64" fill="#DEFFF8" />
                                <path
                                  d="M94.6226 70.3666V48.5778C98.3859 48.0355 101.289 44.7989 101.289 40.8889C101.289 36.6011 97.8004 33.1111 93.5115 33.1111C89.2226 33.1111 85.7337 36.6011 85.7337 40.8889H32.4004V85.3333H65.7904C66.3682 94.6177 74.0848 102 83.5115 102C93.3137 102 101.289 94.0244 101.289 84.2222C101.289 78.6233 98.6815 73.6277 94.6226 70.3666ZM93.5115 35.3333C96.5748 35.3333 99.0671 37.8255 99.0671 40.8889C99.0671 43.9522 96.5748 46.4444 93.5115 46.4444C90.4482 46.4444 87.9559 43.9522 87.9559 40.8889C87.9559 37.8255 90.4482 35.3333 93.5115 35.3333ZM34.6226 43.1111H86.0615C86.3271 43.9978 86.7493 44.8144 87.2915 45.5389L80.4959 52.3344C80.0604 52.1255 79.5804 52 79.0671 52C78.5537 52 78.0737 52.1255 77.6393 52.3344L75.4004 50.0955C75.6082 49.66 75.7337 49.18 75.7337 48.6666C75.7337 46.8289 74.2382 45.3333 72.4004 45.3333C70.5626 45.3333 69.0671 46.8289 69.0671 48.6666C69.0671 49.18 69.1926 49.66 69.4015 50.0944L63.8293 55.6666C63.3937 55.4589 62.9137 55.3333 62.4004 55.3333C60.5626 55.3333 59.0671 56.8289 59.0671 58.6666C59.0671 60.5044 60.5626 62 62.4004 62C64.2382 62 65.7337 60.5044 65.7337 58.6666C65.7337 58.1533 65.6082 57.6733 65.3993 57.2389L70.9715 51.6666C71.4071 51.8744 71.8871 52 72.4004 52C72.9137 52 73.3937 51.8744 73.8282 51.6655L76.0671 53.9044C75.8593 54.34 75.7337 54.82 75.7337 55.3333C75.7337 57.1711 77.2293 58.6666 79.0671 58.6666C80.9048 58.6666 82.4004 57.1711 82.4004 55.3333C82.4004 54.82 82.2748 54.34 82.0659 53.9055L88.8626 47.11C89.8793 47.8722 91.0859 48.3889 92.4004 48.5789V68.8511C89.7815 67.33 86.7515 66.4444 83.5115 66.4444C78.2004 66.4444 73.4382 68.7977 70.1782 72.5033V67.5555H63.5115V80.8889H66.0582C65.9204 81.6144 65.8371 82.3577 65.7904 83.1111H34.6226V43.1111ZM79.0671 54.2222C79.6793 54.2222 80.1782 54.72 80.1782 55.3333C80.1782 55.9466 79.6793 56.4444 79.0671 56.4444C78.4548 56.4444 77.9559 55.9466 77.9559 55.3333C77.9559 54.72 78.4548 54.2222 79.0671 54.2222ZM71.2893 48.6666C71.2893 48.0533 71.7882 47.5555 72.4004 47.5555C73.0126 47.5555 73.5115 48.0533 73.5115 48.6666C73.5115 49.28 73.0126 49.7778 72.4004 49.7778C71.7882 49.7778 71.2893 49.28 71.2893 48.6666ZM63.5115 58.6666C63.5115 59.28 63.0126 59.7777 62.4004 59.7777C61.7882 59.7777 61.2893 59.28 61.2893 58.6666C61.2893 58.0533 61.7882 57.5555 62.4004 57.5555C63.0126 57.5555 63.5115 58.0533 63.5115 58.6666ZM83.5115 93.1111C78.6104 93.1111 74.6226 89.1233 74.6226 84.2222C74.6226 79.3211 78.6104 75.3333 83.5115 75.3333C88.4126 75.3333 92.4004 79.3211 92.4004 84.2222C92.4004 89.1233 88.4126 93.1111 83.5115 93.1111ZM67.9559 75.6344C67.4237 76.5944 66.9837 77.6089 66.6348 78.6666H65.7337V69.7777H67.9559V75.6344ZM82.4004 68.7233V73.1677C76.7937 73.7277 72.4004 78.4711 72.4004 84.2222C72.4004 85.8477 72.7604 87.3889 73.3904 88.7822L69.5359 91.0077C68.5337 88.9544 67.9559 86.6566 67.9559 84.2222C67.9559 76.02 74.3415 69.2966 82.4004 68.7233ZM83.5115 99.7777C78.1626 99.7777 73.4359 97.0633 70.6359 92.9389L74.5059 90.7044C76.5259 93.5022 79.8048 95.3333 83.5115 95.3333C87.2182 95.3333 90.4971 93.5022 92.5171 90.7044L96.3871 92.9389C93.5871 97.0633 88.8604 99.7777 83.5115 99.7777ZM97.4871 91.0077L93.6326 88.7822C94.2626 87.3889 94.6226 85.8477 94.6226 84.2222C94.6226 78.4711 90.2293 73.7266 84.6226 73.1677V68.7233C92.6815 69.2966 99.0671 76.02 99.0671 84.2222C99.0671 86.6566 98.4893 88.9544 97.4871 91.0077Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M83.5114 77.5555C79.8347 77.5555 76.8447 80.5455 76.8447 84.2222C76.8447 87.8989 79.8347 90.8889 83.5114 90.8889C87.1881 90.8889 90.1781 87.8989 90.1781 84.2222C90.1781 80.5455 87.1881 77.5555 83.5114 77.5555ZM83.5114 88.6667C81.0603 88.6667 79.0669 86.6733 79.0669 84.2222C79.0669 81.7711 81.0603 79.7778 83.5114 79.7778C85.9625 79.7778 87.9558 81.7711 87.9558 84.2222C87.9558 86.6733 85.9625 88.6667 83.5114 88.6667Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M36.8447 45.3333H39.0669V47.5555H36.8447V45.3333Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M41.2891 45.3333H56.8446V47.5555H41.2891V45.3333Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M36.8447 49.7778H39.0669V52H36.8447V49.7778Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M41.2891 49.7778H56.8446V52H41.2891V49.7778Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M36.8447 54.2222H39.0669V56.4444H36.8447V54.2222Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M41.2891 54.2222H56.8446V56.4444H41.2891V54.2222Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M36.8447 58.6666H39.0669V60.8888H36.8447V58.6666Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M41.2891 58.6666H56.8446V60.8888H41.2891V58.6666Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M36.8447 80.8889H43.5114V69.7778H36.8447V80.8889ZM39.0669 72H41.2892V78.6667H39.0669V72Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M45.7334 80.8889H52.4001V72H45.7334V80.8889ZM47.9556 74.2222H50.1778V78.6667H47.9556V74.2222Z"
                                  fill="#1ACAA3"
                                />
                                <path
                                  d="M54.623 80.8889H61.2897V63.1111H54.623V80.8889ZM56.8453 65.3333H59.0675V78.6666H56.8453V65.3333Z"
                                  fill="#1ACAA3"
                                />
                              </svg>
                            </span>
                            <span className="content d-block">
                              <span className="heading d-block">
                                Get Started with Reporting
                              </span>
                              <span className="para d-block">
                                Visit the Report Gallery to find the perfect
                                report, then click Add To My Reports to see it
                                here.
                              </span>
                            </span>
                            <span className="guide-arrow">
                              <svg
                                width="311"
                                height="354"
                                viewBox="0 0 411 454"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.77815 452.191C14.1378 451.214 26.4622 452.133 38.8633 451.708C57.2202 451.079 75.729 448.84 94.0439 447.393C140.288 443.737 182.396 427.773 221.509 406.546C247.38 392.504 260.613 370.831 276.858 349.961C287.721 336.005 293.186 315.668 293.494 299.44C293.665 290.448 295.035 282.237 292.356 273.333C289.555 264.025 287.517 254.684 283.319 245.772C280.501 239.788 278.249 233.592 275.462 227.634C272.781 221.904 270.763 214.901 267.288 209.615C264.077 204.731 263.762 196.689 263.326 191.17C262.854 185.204 261.8 179.089 262.66 173.111C264.195 162.455 264.718 150.852 269.63 140.772C278.474 122.624 286.804 106.176 301.446 90.8533C308.96 82.9912 315.941 73.7639 324.978 66.9545C328.525 64.2814 331.089 60.4531 334.869 57.8099C338.051 55.5853 341.445 52.7086 344.271 50.0439C350.665 44.0132 359.904 38.596 367.47 33.6562C373.737 29.565 380.222 24.3023 385.499 19.3405C389.093 15.9616 392.835 11.8939 397.331 9.25707C400.992 7.10951 403.81 3.32938 408.06 1.75576M351.077 10.4992C357.633 8.56305 364.176 7.10077 370.929 5.92206C374.469 5.30414 378.172 4.95255 381.753 4.72269C382.791 4.65608 387.561 4.48937 388.425 3.95296C390.493 2.66846 407.376 0.584461 407.374 1.38087C407.358 7.15555 407.486 13.4134 407.097 18.8306C406.699 24.3652 410.232 29.5427 409.861 34.7088"
                                  stroke="#CACED2"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-dasharray="10 5"
                                />
                              </svg>
                            </span>
                          </div>
                        )}

                        {this.state.showReport && (
                          <ReportRunner
                            reportData={this.state.reportData}
                            showModal={this.state.showReport}
                            lastAPD={this.state.lastAPD}
                            throughAPD={this.state.throughAPD}
                            hideModal={this.hideModal}
                            exportReport={this.exportReport}
                            runFrom={this.state.runFrom}
                            reloadMyReports={() => this.getUserReport()}
                            openScheduleTab={this.openScheduleTab}
                            logReportLoadTiming={this.logReportLoadTiming}
                            modalType="old"
                          ></ReportRunner>
                        )}
                        {this.state.showReportGallery && (
                          <ReportGallery
                            showModal={this.state.showReportGallery}
                            hideReportGalleryModal={this.hideReportGalleryModal}
                            onShowReport={this.onShowReport}
                          ></ReportGallery>
                        )}
                        <div>
                          {this.state.showRenameModal && (
                            <Modal
                              className="rename-report-modal"
                              show={this.state.showRenameModal}
                              onHide={() => this.hideRenameModal()}
                              aria-labelledby="contained-modal-title-vcenter"
                              centered
                              keyboard={false}
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>
                                  {this.state.isDuplicate && "Duplicate Report"}
                                  {this.state.isDuplicate === false &&
                                    "Rename Report"}
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <input
                                  type="text"
                                  value={this.state.newReportName}
                                  onChange={(e) => this.changeReportName(e)}
                                  className="form-control"
                                ></input>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  className="cancel-btn btn-ghost ml-auto"
                                  onClick={() => this.hideRenameModal()}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  disabled={this.state.disableSave}
                                  className="reset-password-btn"
                                  onClick={() => this.saveNewReportName()}
                                >
                                  Save
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Tab>

            {(this.state.allowScheduleView || this.state.allowScheduleEdit) && (
              <Tab eventKey="scheduled" title="Scheduled">
                <div className="budget-settings d-flex justify-content-start">
                  {this.state.activeTab === "scheduled" && (
                    <>
                      <ScheduleReportLeftPanel
                        ref={this.childLeftPanel}
                        reportPermissions={this.state.reportPermissions}
                        allmoduleReports={this.state.allmoduleReports}
                        showRightPanelData={this.showRightPanelData}
                      ></ScheduleReportLeftPanel>
                      {this.state.showRightPanel && (
                        <ScheduleReportRightPanel
                          ref={this.childRightPanel}
                          hideRightPanel={this.hideRightPanel}
                          reloadLeftPanel={this.reloadLeftPanel}
                          onShowReport={this.onShowReport}
                          duplicateReport={this.onduplicateReport}
                          allowScheduleEdit={this.state.allowScheduleEdit}
                          allowScheduleView={this.state.allowScheduleView}
                          confirmOpenReportGallery={
                            this.confirmOpenReportGallery
                          }
                          confirmsetActiveTab={this.confirmsetActiveTab}
                        ></ScheduleReportRightPanel>
                      )}
                    </>
                  )}
                </div>
              </Tab>
            )}
          </Tabs>
        </Container>
      </div>
    );
  }
}
